import React from 'react';
import PropTypes from 'prop-types';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';
import { ThreadFiltersMenuButton }
  from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader/components/ThreadListFilters/components/ThreadFiltersMenu';
import { DataValueMap } from 'Helpers/Testing';
import { FDBox, FDStack } from '@facet-wealth/design';
import {
  IS_ALL_QUERY_FIELD, IS_STARRED_QUERY_FIELD, IS_UNREAD_QUERY_FIELD,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader/components/ThreadListFilters';

const useStyles = buildUseStyles('MemberThreadListFilters', (theme) => ({
  filterButton: {
    margin: 0,
    flex: 'initial',
    width: 'initial',
    padding: theme.spacing(0.5, 1.5),
    height: 30,
  },
}));

const MemberThreadListFilters = ({
  handleToggle,
  debouncedOnSubmit,
  numberOfSelectedFilters,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const {
    isSearching,
  } = useMessagesContext();
  const { resource } = useMetaLayoutContext();

  return (
    <FDStack direction={'column'} spacing={2} paddingY={1}>
      <FDBox {...DataValueMap.init('message-page-search').build()}>
        <MetaControlField
          key={'search'}
          attr={'search'}
          resource={resource}
          onSearch={(value) => debouncedOnSubmit(value)}
          disabled={isSearching}
        />
      </FDBox>
      <FDStack
        spacing={1}
        justifyContent={'flex-end'}
        flexShrink={0}
        alignItems={'center'}
      >
        <MetaControlField
          className={classes.filterButton}
          key={IS_ALL_QUERY_FIELD}
          attr={IS_ALL_QUERY_FIELD}
          attrForTest={IS_ALL_QUERY_FIELD}
          resource={resource}
          onChange={(value) => handleToggle(value, IS_ALL_QUERY_FIELD)}
        />
        <MetaControlField
          className={classes.filterButton}
          key={IS_UNREAD_QUERY_FIELD}
          attr={IS_UNREAD_QUERY_FIELD}
          attrForTest={IS_UNREAD_QUERY_FIELD}
          resource={resource}
          onChange={(value) => handleToggle(value, IS_UNREAD_QUERY_FIELD)}
        />
        <MetaControlField
          className={classes.filterButton}
          key={IS_STARRED_QUERY_FIELD}
          attr={IS_STARRED_QUERY_FIELD}
          attrForTest={IS_STARRED_QUERY_FIELD}
          resource={resource}
          onChange={(value) => handleToggle(value, IS_STARRED_QUERY_FIELD)}
        />
        <ThreadFiltersMenuButton
          onChange={(value, attr) => handleToggle(value, attr)}
          numberOfSelectedFilters={numberOfSelectedFilters}
        />
      </FDStack>
    </FDStack>
  );
};

MemberThreadListFilters.defaultProps = {
};

MemberThreadListFilters.propTypes = {
  handleToggle: PropTypes.func.isRequired,
  debouncedOnSubmit: PropTypes.func.isRequired,
  numberOfSelectedFilters: PropTypes.number.isRequired,
};

export { MemberThreadListFilters };
